import { apiClient } from "../apiClient";

const BASE_URL = "/backend/api/v1/admin/partners";

type ApiEnvelope<T> = {
  body: T;
  error: string | null;
};

export interface Partner {
  id: number;
  name: string;
  white_label_id: number;
  date_created: string;
  date_updated: string;
}

export interface PartnerWithCounts extends Partner {
  bike_count: number;
  station_count: number;
  last_activity: string | null;
}

interface AdminGetPartnersResponse {
  partners: PartnerWithCounts[];
}

interface AdminCreatePartnerResponse {
  partner: Partner;
}

interface AdminUpdatePartnerResponse {
  partner: Partner;
}

export interface VehicleAssignmentResult {
  vehicle_code: string;
  success: boolean;
  error: string | null;
}

interface AdminAssignVehiclesToPartnerResponse {
  results: VehicleAssignmentResult[];
}

export async function getPartners(
  whitelabelId?: number | null
): Promise<PartnerWithCounts[]> {
  const response = await apiClient.get<ApiEnvelope<AdminGetPartnersResponse>>(
    BASE_URL,
    {
      params:
        whitelabelId != null ? { white_label_id: whitelabelId } : undefined,
    }
  );
  return response.data.body.partners;
}

export async function createPartner(
  name: string,
  whitelabelId?: number | null
): Promise<Partner> {
  const response = await apiClient.post<
    ApiEnvelope<AdminCreatePartnerResponse>
  >(BASE_URL, {
    name,
    ...(whitelabelId != null ? { white_label_id: whitelabelId } : {}),
  });
  return response.data.body.partner;
}

export async function updatePartner(
  partnerId: number,
  name: string
): Promise<Partner> {
  const response = await apiClient.put<ApiEnvelope<AdminUpdatePartnerResponse>>(
    `${BASE_URL}/${partnerId}`,
    { name }
  );
  return response.data.body.partner;
}

export async function deletePartner(partnerId: number): Promise<void> {
  await apiClient.delete(`${BASE_URL}/${partnerId}`);
}

export async function bulkAssignVehiclesToPartner(
  partnerId: number,
  vehicleCodes: string[]
): Promise<VehicleAssignmentResult[]> {
  const response = await apiClient.post<
    ApiEnvelope<AdminAssignVehiclesToPartnerResponse>
  >(`${BASE_URL}/assign-vehicles`, {
    partner_id: partnerId,
    vehicle_codes: vehicleCodes,
  });
  return response.data.body.results;
}

export async function bulkUnassignVehiclesFromPartner(
  vehicleCodes: string[]
): Promise<VehicleAssignmentResult[]> {
  const response = await apiClient.post<
    ApiEnvelope<AdminAssignVehiclesToPartnerResponse>
  >(`${BASE_URL}/unassign-vehicles`, {
    vehicle_codes: vehicleCodes,
  });
  return response.data.body.results;
}
